<template>
  <section id="partner" ref="partner" class="spacer half nb">
    <div class="big title">{{ partner.title }}</div>
    <collapse v-for="item in partner.partners" :key="item.uid" :uid="item.uid" class="pad">
      <template v-slot:header>
        <a target="_blank" class="nul" :href="item.link">{{ item.name }}</a>
      </template>
      <template v-slot:left>
        <div class="partner-logo" v-if="item.image">
          <img :src="item.image.url" :alt="item.name" />
        </div>
      </template>
    </collapse>
  </section>
</template>

<script>
import API from "@/api/service";
import Collapse from "@/components/Collapse.vue";

export default {
  components: {
    Collapse
  },
  data() {
    return {
      partner: []
    };
  },
  created() {
    API.partner(this.$i18n.locale).then(page => {
      this.partner = page.data.result;
    });
  },
  // mounted() {
  //   window.addEventListener('scroll', () => {
  //     let marker = window.scrollY + (window.innerHeight / 2);
  //     let start =  this.$refs.partner.offsetTop;
  //     let end =  this.$refs.partner.offsetTop +  this.$refs.partner.offsetHeight;
  //     if(marker > start && marker < end) {
  //       this.$root.$emit('turnoff');
  //     }
  //   });
  // }
};
</script>

<style lang="scss" scoped>
.partner-logo {
  width: 30vw;
  height: 25vw;
  position: absolute;
  top: 50vh;
  left: 50%;
  transform: translate(-50%, -50%);
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>
